// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lzgipsyuloqrhfpfoudo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6Z2lwc3l1bG9xcmhmcGZvdWRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwODIyMzksImV4cCI6MjA1ODY1ODIzOX0.BXWcZnxVbrQ6RcZbx44NGzEqj7Ugij-6b77sgG_zrSE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);